import { BankAccountTypes, SavedPaymentMethodFullResponse } from 'types';

import { api } from './api';

export type AddPaymentMethodData = {
  bankAccount: {
    accountNumber: string;
    routingNumber: string;
    bankAccountType: BankAccountTypes;
    accountHolderName: string;
    isAccountValidated?: boolean;
  };
  setAsAutoPay: true;
};

export const paymentMethodsApi = api.injectEndpoints({
  endpoints: (build) => ({
    getPaymentMethodsByAccountId: build.query<SavedPaymentMethodFullResponse[], { id: string }>({
      query: ({ id }) => ({
        url: `v2/accounts/${id}/payment-methods`,
        params: { fullResponse: true },
      }),
      providesTags: (_result, _error, { id }) => [{ type: 'FinancialAccountDocument', id }],
    }),
    editPaymentMethodInformation: build.mutation<
      SavedPaymentMethodFullResponse,
      { id: string; data: AddPaymentMethodData }
    >({
      query: ({ id, data }) => ({
        url: `v2/accounts/${id}/payment-methods`,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: (_result, _error, { id }) => [
        { type: 'FinancialAccountDocument', id },
        { type: 'Accounts', id },
        { type: 'AccountMilestones', id },
      ],
    }),
    deletePaymentMethod: build.mutation<void, { accountId: string; financialAccountId: string }>({
      query: ({ accountId, financialAccountId }) => ({
        url: `v2/accounts/${accountId}/payment-methods/${financialAccountId}`,
        method: 'DELETE',
      }),
      invalidatesTags: (_result, _error, { accountId }) => [{ type: 'FinancialAccountDocument', id: accountId }],
    }),
  }),
});

export const {
  useGetPaymentMethodsByAccountIdQuery,
  useEditPaymentMethodInformationMutation,
  useDeletePaymentMethodMutation,
} = paymentMethodsApi;
